module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inquiry"
  }, [_c('MentoringDescription'), _c('MentoringProcess'), _c('Button', {
    attrs: {
      "big": true,
      "short": true
    },
    on: {
      "click": _vm.goToRequests
    }
  }, [_vm._v("Начать")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69f7c21d","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/mentoring/views/inquiry/MentoringInquiry.vue
// module id = 585e17459726fe45ddeb
// module chunks = 56